"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MessageHeartOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16 7.7a3.8 3.8 0 00-4.9.4 4 4 0 000 5.5l4 4a1.3 1.3 0 00.9.4 1.5 1.5 0 001-.4l4-4a4 4 0 000-5.4 3.8 3.8 0 00-5-.5zm4 3.2a1.9 1.9 0 01-.5 1.2L16 15.7l-3.5-3.5a1.9 1.9 0 01-.5-1.3 1.9 1.9 0 01.5-1.3 1.8 1.8 0 011.3-.6 1.8 1.8 0 011.3.5l.9 1 1-1a1.8 1.8 0 012.5 0 1.9 1.9 0 01.5 1.4z"/><path d="M27 3H5a3 3 0 00-3 3v13a3 3 0 003 3h3v6a1 1 0 000 .4 1 1 0 00.6.5 1 1 0 00.8 0 1 1 0 00.3-.2l6.7-6.7H27a3 3 0 003-3V6a3 3 0 00-3-3zm1 3v13a1 1 0 01-1 1H16a1 1 0 00-.7.3L10 25.6V22c.3-1-1-2-2.1-2H5a1 1 0 01-1-1V6a1 1 0 011-1h22a1 1 0 011 1z"/>';
var MessageHeartOutlineSVG = function MessageHeartOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MessageHeartOutlineSVG = MessageHeartOutlineSVG;
MessageHeartOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MessageHeartOutlineSVG);
exports.default = _default;